import { PLATFORMSUPPORT } from './config.js';
let util = {};

// 获取指定 key 值
util.handleInitKey = (data, keyNames, countLoop, callBack) => {
    let keyNameLength = keyNames.length;
    data = data[keyNames[countLoop]];
    if(!data) return [];
    countLoop+=1;
    if(countLoop >= keyNameLength){
        callBack(Array.isArray(data) ? data : [data]);
    }else{
        util.handleInitKey(data, keyNames, countLoop, callBack);
    }
};

/**
 *  格式化时间  日期 比如 new Date()
 */
util.dateFormat = (date) => {
    if(!date){
        return '';
    }else {
        date = new Date(date);
    }
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    if (hours < 10) {
        hours = '0' + hours
    }
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
    const t = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    return t;
};

// 修改数结构属性名称
util.propertyTree = (data, keysValue) => {
    let item = [];
    data.forEach(list => {
        let newData = {};
        newData.value = list[keysValue.value];
        newData.label = list[keysValue.label];
        newData.children = list[keysValue.children] ? util.propertyTree(list[keysValue.children],keysValue) : [];
        item.push(newData);
    });
    return item;
};

// 获取浏览器 / 操作系统信息 / 是否支持 webGL
util._handleBroInfo = () => {
    let broName = 'Runing';
    let browserKernel = '';
    let strStart = 0;
    let strStop = 0;
    let temp = '';
    let userAgent = window.navigator.userAgent;
    let info = '';
    let os = window.navigator.platform;

    // 判断浏览器是否支持 webGL
    let Detector = {
        canvas: !!window.CanvasRenderingContext2D,
        webgl: (function() {
            try {
                let canvas = document.createElement('canvas');
                return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
            } catch(e) {
                return false;
            }
        })(),
        workers: !!window.Worker,
        fileapi: window.File && window.FileReader && window.FileList && window.Blob,
        getWebGLErrorMessage: function() {
            let element = document.createElement('div');
            element.id = 'webgl-error-message';
            element.style.fontFamily = 'monospace';
            element.style.fontSize = '13px';
            element.style.fontWeight = 'normal';
            element.style.textAlign = 'center';
            element.style.background = '#fff';
            element.style.color = '#000';
            element.style.padding = '1.5em';
            element.style.width = '400px';
            element.style.margin = '5em auto 0';
            if(!this.webgl) {
            element.innerHTML = window.WebGLRenderingContext ? [
                'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" rel="external nofollow" rel="external nofollow"  style="color:#000">WebGL</a>.<br />',
                'Find out how to get it <a href="http://get.webgl.org/" rel="external nofollow" rel="external nofollow"  style="color:#000">here</a>.'
            ].join('\n') : [
                'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" rel="external nofollow" rel="external nofollow"  style="color:#000">WebGL</a>.<br/>',
                'Find out how to get it <a href="http://get.webgl.org/" rel="external nofollow" rel="external nofollow"  style="color:#000">here</a>.'
            ].join('\n');
            }
            return element;
        },
        addGetWebGLMessage: function(parameters) {
            let parent, id, element;
            parameters = parameters || {};
            parent = parameters.parent !== undefined ? parameters.parent : document.body;
            id = parameters.id !== undefined ? parameters.id : 'oldie';
            element = Detector.getWebGLErrorMessage();
            element.id = id;
            parent.appendChild(element);
        }
    };
      
    //FireFox
    if (userAgent.indexOf('Firefox') != -1) {
        /*broName = 'FireFox浏览器';*/
        strStart = userAgent.indexOf('Firefox');
        temp = userAgent.substring(strStart);
        broName = temp.replace('/', '版本号')
        browserKernel = 'Firefox';
    }
    //Edge
    if (userAgent.indexOf('Edge') != -1) {
        /*broName = 'Edge浏览器';*/
        strStart = userAgent.indexOf('Edge');
        temp = userAgent.substring(strStart);
        broName = temp.replace('/', '版本号');
        browserKernel = 'Edge';
    }
    //IE浏览器
    if (userAgent.indexOf('NET') != -1 && userAgent.indexOf("rv") != -1) {
        /*broName = 'IE浏览器'; */
        strStart = userAgent.indexOf('rv');
        strStop = userAgent.indexOf(')');
        temp = userAgent.substring(strStart, strStop);
        broName = temp.replace('rv', 'IE').replace(':', '版本号');
        browserKernel = 'IE';
    }
    //360极速模式可以区分360安全浏览器和360极速浏览器
    if (userAgent.indexOf('WOW') != -1 && userAgent.indexOf("NET") < 0 && userAgent.indexOf("Firefox") < 0) {
        if(navigator.javaEnabled()){
            broName = '360安全浏览器-极速模式';
            browserKernel = '360安全浏览器-极速模式';
        }else{
            broName = '360极速浏览器-极速模式';
            browserKernel = '360极速浏览器-极速模式';
        } 
    }
    //360兼容
    if (userAgent.indexOf('WOW') != -1 && userAgent.indexOf("NET") != -1 && userAgent.indexOf("MSIE") != -1 && userAgent.indexOf("rv") < 0) {
        broName = '360兼容模式';
        browserKernel = '360兼容模式';
    }
    //Chrome浏览器
    if (userAgent.indexOf('WOW') < 0 && userAgent.indexOf("Edge") < 0) {
        /*broName = 'Chrome浏览器';*/
        strStart = userAgent.indexOf('Chrome');
        strStop = userAgent.indexOf(' Safari');
        temp = userAgent.substring(strStart, strStop);
        if(strStart != -1 || strStop != -1){
            broName = temp.replace('/', '版本号');
            browserKernel = 'Chrome';
        }
    }

    // 判断操作系统 
    if (os.indexOf("Win") > -1) {  
        if (userAgent.indexOf("Windows NT 5.0") > -1) {  
            info += "Win2000";  
        } else if (userAgent.indexOf("Windows NT 5.1") > -1) {  
            info += "WinXP";  
        } else if (userAgent.indexOf("Windows NT 5.2") > -1) {  
            info += "Win2003";  
        } else if (userAgent.indexOf("Windows NT 6.0") > -1) {  
            info += "WindowsVista";  
        } else if (userAgent.indexOf("Windows NT 6.1") > -1 || userAgent.indexOf("Windows 7") > -1) {  
            info += "Win7";  
        } else if (userAgent.indexOf("Windows NT 6.2") > -1 || userAgent.indexOf("Windows 8") > -1) {  
            info += "Win8";  
        } else if (userAgent.indexOf("Windows NT 6.3") > -1 || userAgent.indexOf("Windows 8.1") > -1) {  
            info += "Win8.1";  
        } else if (userAgent.indexOf("Windows NT 10.0") > -1 || userAgent.indexOf("Windows 10") > -1) {  
            info += "Win10";  
        }  
        else {  
            info += "Other";  
        }  
    } else if (os.indexOf("Mac") > -1) {  
        info += "Mac";  
    } else if (os.indexOf("X11") > -1) {  
        info += "Unix";  
    } else if (os.indexOf("Linux") > -1) {  
        info += "Linux";  
    } else {  
        info += "Other";  
    }
    
    return { broName, browserKernel, operatingSystem: info, isWebGL: Detector.webgl };
};

// xboot系统按钮权限隐藏操作
util._handleButtonShow = (router, value) => {
    if(!router.history) return;
    return router.history.current.meta.permTypes.indexOf(value) != -1;
};


// 下载链接需要参数时使用
util._handleDownloadFile = (urlData, queryData) => {
    let openUrl = `${ urlData.base }${ urlData.url }?`;
    for (const key in queryData) {
        openUrl += `${ key }=${ queryData[key] }&`
    }
    openUrl = openUrl.substr(0,openUrl.length - 1);
    window.open(openUrl);
};

// 校验 Luhn 算法
util._handleCheckCardLuhn = (codeNo,digitNum) => {
    if(isNaN(codeNo))
        return false;
    if(codeNo.length < digitNum){
        return false;
    }
    let nums = codeNo.split("");
    let sum = 0;
    let index = 1;
    for(let i = 0 ; i < nums.length; i++){
        if((i+1)%2==0){
            let tmp = Number(nums[nums.length-index])*2;
            if(tmp >= 10){
                let t = tmp+"".split("");
                tmp = Number(t[0]) + Number(t[1]);
            }
            sum+=tmp;
        }else{
            sum+=Number(nums[nums.length-index]);
        }
        index ++;
    }
    if(sum%10 != 0){
        return false;
    }
    return true;
}

// 校验
util._handleCheckSupport = (key, value) => {
    let proposal;
    if(key == 'computerSystem'){
        // 校验电脑系统
        if(PLATFORMSUPPORT[value] == 1){
            proposal = 1;
        }
        if(PLATFORMSUPPORT[value] == 2){
            proposal = 2;
        }
        if(PLATFORMSUPPORT[value] == 3){
            proposal = 3;
        }
        return {
            platform: PLATFORMSUPPORT[value],
            proposal
        }
    }
    if(key == 'graphicsHardware'){
        // 显卡和硬件设备
        if(PLATFORMSUPPORT){
            proposal = 4;
        } else{
            proposal = 5;
        }
        return {
            platform: value ? 1 : 3,
            proposal
        }
    }
    if(key == 'browserKernel'){
        if(PLATFORMSUPPORT[value] == 1){
            proposal = 6;
        }
        if(PLATFORMSUPPORT[value] == 2){
            proposal = 7;
        }
        if(PLATFORMSUPPORT[value] == 3){
            proposal = 8;
        }
        // 浏览器内核
        return {
            platform: PLATFORMSUPPORT[value],
            proposal
        }
    }
};

export default util;


//////////////////
// WEBPACK FOOTER
// /Users/wangmengyuan/Code/xbz-students-web/vendor/xbz-front-compilb/src/libs/util.js
// module id = null
// module chunks = 